export default __webpack_public_path__ + "static/media/dms.7213143a.png";